export function CloudSyncScene({ className = "" }) {
  const paths = ["M60 170 L200 50", "M200 170 L200 50", "M340 170 L200 50"];
  return (
    <svg viewBox="0 0 400 240" className={`w-full ${className}`} aria-hidden="true" data-testid="landing-cloud-scene">
      {paths.map((d) => <path key={d} d={d} stroke="rgba(255,255,255,0.5)" strokeWidth="1.6" strokeDasharray="5 5" fill="none" className="cs-dash" />)}
      <g className="cs-float">
        <path d="M160 70 h80 a20 20 0 0 0 -4 -39 a28 28 0 0 0 -52 -6 a22 22 0 0 0 -24 45 z" fill="#fff" />
      </g>
      {[60, 200, 340].map((x, i) => (
        <g key={x}>
          <rect x={x - 22} y="170" width="44" height="56" rx="8" fill="#061436" stroke="#fff" strokeWidth="2.5" />
          <rect x={x - 14} y="182" width="28" height="4" rx="2" fill="#fff" opacity="0.7" />
          <rect x={x - 14} y="192" width="18" height="4" rx="2" fill="#FFB347" />
          <circle cx={x} cy="170" r="6" fill="#FFB347" className="cs-node" style={{ animationDelay: `${i * 0.4}s` }} />
        </g>
      ))}
      {paths.map((d, i) => (
        <circle key={`p${d}`} r="3.5" fill="#FFB347">
          <animateMotion dur="2.2s" repeatCount="indefinite" begin={`${i * 0.5}s`} path={d} keyPoints={i === 1 ? "1;0" : "0;1"} keyTimes="0;1" calcMode="linear" />
        </circle>
      ))}
    </svg>
  );
}
